import { __rest } from "tslib";
import * as React from 'react';
import { ClassNames } from '../../utils/classNames';
import { Input } from '../input/input.component';
/** Wrap up a text input with type=email */

export var EmailInput = React.forwardRef(function (_a, ref) {
  var className = _a.className,
      props = __rest(_a, ["className"]);

  return React.createElement(Input, Object.assign({}, props, {
    className: ClassNames.concat('arm-email-input', className),
    ref: ref,
    type: "email"
  }));
});